<template>
  <div class="ft">
    <topNav ref="topnav"
            :title="isMultSelect? mutlSelectTitle : $t('fangT_title')"
            :selectMore="true"
            @goSelect="goSelect"
            @operateMultSelected="operateMultSelected"
            @cancleSelectMore="cancleSelectMore"></topNav>
    <div class="fangt_top">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text"
               id='searchInput'
               x-webkit-speech
               v-model='searchOption.searchText'
               name=""
               :placeholder="$t('fangT_placeholder')">
        <div class="cleartext"
             @click="searchOption.searchText='';getData();"
             v-if="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
        <template v-else>
          <div class="cleartext"
               v-if='isJingJiang'>
            <i class="iconfont icon-qiapian"
               @click="getJingJiangToken('readCard')"></i>
          </div>
          <div class="cleartext"
               v-else>
            <i class="iconfont icon-yuyin"
               @click="startRecognize"></i>
          </div>
        </template>
      </div>
      <div class="searct_btn"
           @click='getData'>{{ $t('search') }}
      </div>
      <span class="line"></span>
      <div class="fliter"
           @click="showFliter">{{ $t('fliter') }}
        <i class="iconfont icon-xia"></i>

        <span class='filter-red-dot'
              v-if='hasSelectFilter'></span>
      </div>
    </div>

    <mt-loadmore :top-method="loadTop"
                 :topDistance="70"
                 :maxDistance="180"
                 @top-status-change="handleTopChange"
                 :top-status.sync="topStatus"
                 ref="loadmore">


      <div class="all_ft">
        <template v-if="openFloor == 'yes'">
          <div class="build-wrap" v-for="(build, indexFloor) in withFloorDataArr" :key="'withFloorDataArr' + indexFloor">
            <div class="floor-title">{{getFloorTitle(build.floorCode) || ''}}</div>
            <div class="roomList"
                 :style='{width: iconWidth, maxWidth: (isJingJiang ? "none" : "2.17rem")}'
                 v-for='(item,key) in build.list'
                 @click='touchitem(item)'
                 :key="item.rmno">
              <div class="item"
                   :style='{background:item.c,color:roomList.fontColor}'
                   :class="{'rightBorder':(key+1)%5!=0,'arrT': item.arr == 'T'}">
                <p class="roomNo">
                  {{ item.rmno }}
                </p>
                <p class="roomType"
                   v-if="localShowRmtype == 'yes'"
                   :class="{'rms': item.rmtype && (item.rmtype.length>=6)}">
                  {{item.rmtype}}
                </p>
                <p class="roomType"
                   v-else
                   :class="{'rms':item.abbreviated && (item.abbreviated.length>=6)}">
                  {{ item.abbreviated }}
                </p>

                <p class="roomType"
                   :class="{'rms':item.names.length>6}">
                  {{ item.names }}
                </p>
                <div class="multChoice"
                     :class="{'choiced':item.choiced}"
                     v-show="isMultSelect">

                  <div class="mult-cicle">
                    <i class="iconfont icon-right">
                    </i>
                  </div>
                </div>
                <p v-if="item.arr == 'T'">→</p>

                <!--将离状态 icon d == 1-->
                <i v-if='item.d == 1'
                   class='room-status-icon iconfont icon-peopleb2ren'> </i>
              </div>
            </div>
          </div>

        </template>
        <template v-else-if="openBuilding == 'yes'">

          <div class="build-wrap" v-for="(build, indexBuild) in withBuildDataArr" :key="'withBuildDataArr' + indexBuild">
            <div class="build-title">{{getBuildingTitle(build.buildCode) || ''}}</div>
            <div class="roomList"
                 :style='{width: iconWidth, maxWidth: (isJingJiang ? "none" : "2.17rem")}'
                 v-for='(item,key) in build.list'
                 @click='touchitem(item)'
                 :key="item.rmno">
              <div class="item"
                   :style='{background:item.c,color:roomList.fontColor}'
                   :class="{'rightBorder':(key+1)%5!=0,'arrT': item.arr == 'T'}">
                <p class="roomNo">
                  {{ item.rmno }}
                </p>
                <p class="roomType"
                   v-if="localShowRmtype == 'yes'"
                   :class="{'rms': item.rmtype && (item.rmtype.length>=6)}">
                  {{item.rmtype}}
                </p>
                <p class="roomType"
                   v-else
                   :class="{'rms':item.abbreviated && (item.abbreviated.length>=6)}">
                  {{ item.abbreviated }}
                </p>

                <p class="roomType"
                   :class="{'rms':item.names.length>6}">
                  {{ item.names }}
                </p>
                <div class="multChoice"
                     :class="{'choiced':item.choiced}"
                     v-show="isMultSelect">

                  <div class="mult-cicle">
                    <i class="iconfont icon-right">
                    </i>
                  </div>
                </div>
                <p v-if="item.arr == 'T'">→</p>

                <!--将离状态 icon d == 1-->
                <i v-if='item.d == 1'
                   class='room-status-icon iconfont icon-peopleb2ren'> </i>
              </div>
            </div>
          </div>

        </template>
        <template v-else>
          <div class="roomList"
               :style='{width: iconWidth, maxWidth: (isJingJiang ? "none" : "2.17rem")}'
               v-for='(item,key) in roomList.statusresult'
               @click='touchitem(item)'
               :key="item.rmno">
            <div class="item"
                 :style='{background:item.c,color:roomList.fontColor}'
                 :class="{'rightBorder':(key+1)%5!=0,'arrT': item.arr == 'T'}">
              <p class="roomNo">
                {{ item.rmno }}
              </p>
              <p class="roomType"
                 v-if="localShowRmtype == 'yes'"
                 :class="{'rms': item.rmtype && (item.rmtype.length>=6)}">
                {{item.rmtype}}
              </p>
              <p class="roomType"
                 v-else
                 :class="{'rms':item.abbreviated && (item.abbreviated.length>=6)}">
                {{ item.abbreviated }}
              </p>

              <p class="roomType"
                 :class="{'rms':item.names.length>6}">
                {{ item.names }}
              </p>
              <div class="multChoice"
                   :class="{'choiced':item.choiced}"
                   v-show="isMultSelect">

                <div class="mult-cicle">
                  <i class="iconfont icon-right">
                  </i>
                </div>
              </div>
              <p v-if="item.arr == 'T'">→</p>

              <!--将离状态 icon d == 1-->
              <i v-if='item.d == 1'
                 class='room-status-icon iconfont icon-peopleb2ren'> </i>
            </div>
          </div>
        </template>
        <nothing :condition="roomList.statusresult != null && roomList.statusresult.length == 0"></nothing>
      </div>
      <div slot="top"
           class="mint-loadmore-top">
        <span v-show="topStatus !== 'loading'"
              :class="{ 'rotate': topStatus === 'drop' }"> ↓ {{ $t('index_refresh') }}</span>
        <span v-show="topStatus === 'loading'">Loading...</span>
      </div>
    </mt-loadmore>
    <div class="fboot"></div>
    <div class="foot_ft"
         :class='{change:popupFootVisible,l_o_btm:!popupFootVisible}'>
      <mt-popup v-model='popupFootVisible'
                position="bottom"
                style="bottom: 2.96rem;"
                class="footPop"
                :modal="false">
        <div class="foot_c "
             style="display:block">
          <div style="width:37.5rem">
            <div class="top"
                 :class='{checked:item.status==searchOption.filterKey}'
                 v-for='item in roomList.filter'
                 :key="item.status"
                 @click='setInfo(item)'>
              <div class="cicle"
                   :style="{background:item.color,borderColor:item.color}">
                <!-- 将离需要加个icon -->
                <i v-if="item.status == 'DEP'"
                   class='dep-icon iconfont icon-peopleb2ren'> </i>
              </div>
              {{ item.name }}({{ item.num }})
            </div>
          </div>
        </div>
      </mt-popup>

      <div class="foot_d">
        <div class="clearfix flotwarp">
          <div class="bottom"
               v-for='item in roomList.status'
               @click='setInfo(item)'
               :key="item.status">
            <div class="checkbox"
                 :class='{checked:item.status==searchOption.filterKey}'>
              <div class="dimetric"
                   :style="{background:item.color,borderColor:item.color}"></div>
              {{ item.name }}({{ item.num }})
            </div>
          </div>
        </div>
        <div class="showFBtn"
             @touchstart='showFoot'>
          <i class="iconfont icon-shanga"></i>
        </div>
      </div>
    </div>
    <actionsheet :actions="actions"
                 v-model="sheetVisible"
                 :cancelText="$t('cancel')"></actionsheet>

    <mt-popup v-model="popupVisible3"
              position="right"
              @touchmove.stop
              class="mint-popup-3 rightFliterBox"
              :modal="true">
      <div class="rightFliterBox">
        <div class="filter_title">
          <span class="title">{{ $t('fliter') }}</span>
          <mt-button @click.native="popupVisible3 = false">
            <i class="iconfont icon-cuowu"></i>
          </mt-button>
        </div>
        <div class="fliter_item"
             v-for='(itemF,index) in rightList'
             :key="'rightList' + index"
             v-if='!!serchList[itemF.node] && serchList[itemF.node].length>1'>
          <div class="category_name">
            <span>{{ itemF.name }}</span>
            <p class="showCategory"
               @click='showmore(index)'
               v-if='!!serchList[itemF.node]&&serchList[itemF.node].length>4'>{{ $t('all') }}
              <i class="iconfont icon-xia2 "
                 :class="{open:rightList[index].more=='T'}"></i>
            </p>
          </div>
          <div class="category_list clearfix"
               :class="{twocol:itemF.node!='building',show:itemF.more=='T'}">
            <div v-for='(item,index) in serchList[itemF.node]'
                 :key="'serchList-itemF-node' + index">
              <div class="option oplist"
                   :class='{checked:item.code==searchOption[itemF.node]}'
                   @click='selectSelf(itemF.node,item)'>{{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!--其他-->
        <div class="fliter_item">
          <div class="category_name">
            <span>{{ $t('other') }}</span>
          </div>
          <div class="category_list clearfix twocol">
            <div v-for='(item,index) in serchList["filter"]'
                 :key="'serchList-filter' + index">
              <div class="option oplist"
                   :class='{checked:item.code==searchOption.filterKey}'
                   @click='selectSelf("filterKey",item)'>{{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!--大小房-->
        <div class="fliter_item"
             v-if="roomList.isVilla">
          <div class="category_name">
            <span>{{ $t('fangT_category_name') }}</span>
          </div>
          <div class="category_list clearfix twocol">
            <div v-for='(item,index) in villadata'
                 :key="'villadata' + index">
              <div class="option oplist"
                   :class='{checked:item.code==searchOption.villa}'
                   @click='selectSelf("villa",item)'>{{ item.name }}
              </div>
            </div>
          </div>
        </div>

        <!--按照楼栋分类-->
        <div class="fliter_item"
             v-if="showBuilding">
          <div class="category_name">
            <span>按照楼栋分组</span>
          </div>
          <div class="category_list clearfix twocol">
            <div class="option oplist"
                 :class='{checked: openBuilding=="yes"}'
                 @click='toggleShowBuilding("yes")'>开启
            </div>
            <div class="option oplist"
                 :class='{checked:  openBuilding=="no"}'
                 @click='toggleShowBuilding("no")'>关闭
            </div>
          </div>
        </div>

        <!--按照楼栋分类-->
        <div class="fliter_item"
             v-if="showFloor">
          <div class="category_name">
            <span>按楼层</span>
          </div>
          <div class="category_list clearfix twocol">
            <div class="option oplist"
                 :class='{checked: openFloor=="yes"}'
                 @click='toggleShowFloor("yes")'>开启
            </div>
            <div class="option oplist"
                 :class='{checked:  openFloor=="no"}'
                 @click='toggleShowFloor("no")'>关闭
            </div>
          </div>
        </div>

        <div class="fliter_item">
          <div class="category_name">
            <span>展示房型代码</span>
          </div>
          <div class="category_list clearfix twocol">
            <div class="option oplist"
                 :class='{checked: localShowRmtype=="yes"}'
                 @click='toggleShowRmtype("yes")'>开启
            </div>
            <div class="option oplist"
                 :class='{checked:  localShowRmtype=="no"}'
                 @click='toggleShowRmtype("no")'>关闭
            </div>
          </div>
        </div>

        <div class="bottom_f">
          <div class="reset"
               @click='reset'> {{ $t('reset') }}
          </div>
          <div class="success"
               @click='sendData'> {{ $t('complete') }}
          </div>
        </div>
      </div>
    </mt-popup>


    <mt-popup v-model="popupVisibleSta"
              position="bottom"
              class="checkOutPop"
              :modal="true">
      <div class="checkList mutlList">
        <label>{{ $t('fangT_rmno') }}：</label>{{ sheetTemp.rmno }}
      </div>
      <mt-radio :title="$t('fangT_staNew')"
                :max="1"
                v-model="staNew"
                :options="stas">
      </mt-radio>

      <div class="checkList" v-if="updateRoomStaForThef && (staNew == 'R')">
        <label style="padding-right: 5px;">选择服务员 : </label>
        <select class="ooreason"
                v-model="houseKeeper">
          <option value=""></option>
          <option :value="item.CODE"
                  v-for="item in serverList"
                  :key="item.CODE">{{ item.descript }}
          </option>
        </select>
      </div>
      <div class="popBottom">
        <div class="cCancle"
             @click='popupVisibleSta=false'>{{ $t('cancel') }}
        </div>
        <div class="cSure"
             @click="updateSta">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupVisibleStaOS"
              position="bottom"
              class="checkOutPop pos"
              :modal="true">
      <div class="checkList mutlList"
           style="margin-top:30px">
        <label>{{ $t('fangT_rmnos') }}:</label>
        <input type="text"
               style="height:35px;border:0"
               v-model="staOOReq.rmnos"
               :placeholder="$t('fangT_rmnos_placeholder')">
      </div>
      <div class="checkList">
        <label>{{ $t('fangT_sta') }} :</label>
        <div>{{ staOOReq.sta == 'O' ? $t('maintenance') : $t('lock') }}</div>
      </div>
      <div class="checkList">
        <label>{{ $t('fangT_beginDate') }} :</label>
        <div @click="openPick('picker')">{{ staOOReq.beginDate | fdate }}</div>
      </div>
      <div class="checkList">
        <label>{{ $t('fangT_endDate') }} :</label>
        <div @click="openPick('picker2')">{{ staOOReq.endDate | fdate }}</div>
      </div>
      <div class="checkList">
        <label>{{ $t('fangT_reasonCode') }} :</label>
        <select class="ooreason"
                v-model="staOOReq.reasonCode">
          <option value=""></option>
          <option :value="item.code"
                  v-for="item in ooReasonSlot"
                  :key="item.code">{{ item.name }}
          </option>
        </select>
      </div>
      <div class="checkList">
        <label> {{ $t('remark') }} :</label>
        <div><input type="text"
                    style="height:35px;border:0"
                    v-model="staOOReq.remark"
                    :placeholder="$t('fangT_remark_placeholder')"></div>
      </div>
      <div class="popBottom">
        <div class="cCancle"
             @click='popupVisibleStaOS=false'> {{ $t('cancel') }}
        </div>
        <div class="cSure"
             @click="updateStaO">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>
    <mt-datetime-picker ref="picker"
                        type="date"
                        @confirm="handleConfirm"
                        :startDate="minDate"
                        v-model="staOOReq.beginDate"></mt-datetime-picker>
    <mt-datetime-picker ref="picker2"
                        type="date"
                        :startDate="minDate"
                        v-model="staOOReq.endDate"></mt-datetime-picker>

    <div class='door-card-modal'
         v-if='doorCardModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>{{ $t('jj_door_card_info') }}</div>
        <div class='door-card-info'>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_room_no') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.roomNo }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_beginTime') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.beginTime }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_endTime') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.endTime }}</div>
          </div>
        </div>

        <div class='door-card-bottom'>
          <div class='door-btns'
               @click='closeDoorCardModal'>{{ $t('shutDown') }}
          </div>
          <div class='door-btns'
               @click='getJingJiangToken("cancelCard")'>{{ $t('jj_cancel_text') }}
          </div>
          <div class='door-btns'
               @click='searchDoorCardModal'>{{ $t('view') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Actionsheet,
  Radio,
  Picker,
  MessageBox
} from 'mint-ui';
import nothing from '../common/nothing';
import moment from 'moment';
import {mapState, mapGetters} from 'vuex';
import _ from 'underscore'

export default {
  data() {
    return {
      mutlSelectTitle: this.$t('fangT_mutlSelectTitle'),
      localShowRmtype: localStorage.getItem('localShowRmtype') == 'yes' ? 'yes' : 'no',
      //   multChoicedArr:[],
      showBuilding: false, // 展示按楼栋分组
      openBuilding: localStorage.getItem('fangTopenBuilding') == 'yes' ? 'yes' : 'no',
      showFloor: false, // 按楼层分组
      openFloor: localStorage.getItem('fangTopenFloor') == 'yes' ? 'yes' : 'no',
      buildingArr: [],
      withBuildDataArr: [],
      withFloorDataArr: [],
      roomList: [],
      serchList: [],
      popupVisible3: false,
      popupFootVisible: false,
      rightList: [
        //楼栋
        {
          name: this.$t('fangT_building'),
          node: 'building',
          more: 'F'
        },
        //楼层
        {
          name: this.$t('fangT_floor'),
          node: 'floor',
          more: 'F'
        },
        //房型
        {
          name: this.$t('fangT_rmtype'),
          node: 'rmtype',
          more: 'F'
        },
        //特征
        {
          name: this.$t('fangT_feature'),
          node: 'feature',
          more: 'F'
        }
      ],
      searchOption: {
        searchText: '',
        filterKey: '',
        building: '',
        rmtype: '',
        floor: '',
        feature: '',
        villa: ''
      },
      stas: [
        //检查
        {
          label: this.$t('fangT_RoomStaI'),
          value: 'I'
        },
        //干净
        {
          label: this.$t('fangT_RoomStaR'),
          value: 'R'
        },
        //楼栋
        {
          label: 'Touch-Up',
          value: 'T'
        },
        //脏房
        {
          label: this.$t('fangT_RoomStaD'),
          value: 'D'
        }
      ],
      villadata: [{
        code: 'V',
        name: this.$t('fangT_villadataV')
      }, //"可用"
        {
          code: 'B',
          name: this.$t('fangT_villadataB')
        }, // "大房" },
        {
          code: 'S',
          name: this.$t('fangT_villadataS')
        } //"小房" }
      ],
      popupVisibleSta: false,
      staNew: '',
      topStatus: '',
      sheetTemp: {},
      sheetVisible: false,
      actions: [],
      popupVisibleStaOS: false,
      ooReasonSlot: null,
      staOOReq: {
        reasonCode: '',
        sta: '',
        remark: '',
        rmnos: '',
        beginDate: moment(moment().format('YYYY-MM-DD')).toDate(),
        endDate: moment(
          moment()
            .add(1, 'd')
            .format('YYYY-MM-DD')
        ).toDate()
      },
      minDate: moment(moment().format('YYYY-MM-DD')).toDate(),
      isMultSelect: false, //是否是多选状态

      // 锦江读取身份证
      isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      jingJiangToken: '',
      HotelId: '',
      Key: '',
      configObj: {
        'Category': 1,
        'CardType': 'GuestCard',
      },
      ResponseParameters: {
        roomNo: '',
        beginTime: '',
        endTime: '',
      },
      doorCardModalShow: false,
      listened: false,
      tempRoomNo: '',
      iconWidth: localStorage.getItem('isJingJiang') == 'yes' ? (window.screen.width / 5) + 'px' : '2rem',
      currentRoomName: '',

      useMhPermission: localStorage.getItem('useMhPermission') == 'yes', // 启用新权限

      // 商务版房态改为干净的时候要加服务员，统计业绩用，商务版并且满足开关才有需要
      updateRoomStaForThef: localStorage.getItem('isThefClient') == 'yes' && localStorage.getItem('updateRoomStaForThef') == 'yes',
      serverList: [], // 服务员列表
      houseKeeper: '',

      showPswd:false,
    };
  },

  mounted() {
    let that = this
    if (this.$route.query.type == 'jingjiang') {
      this.tempRoomNo = this.$route.query.roomNo
      this.ResponseParameters = {
        roomNo: this.$route.query.roomNo,
        beginTime: this.$route.query.beginTime,
        endTime: this.$route.query.endTime,
      }
      this.doorCardModalShow = true
    } else {
      this.getLocalSearchOption()
    }
    this.getData();
    this.getFilter();
    if (this.updateRoomStaForThef) {
      this.getRoomServerList();
    }
    this.initJingJiangListen()
    this.getIfPswd()
  },
  methods: {
    toggleShowBuilding(val) {
      this.openBuilding = val
      localStorage.setItem('fangTopenBuilding', val)
    },
    toggleShowFloor(val) {
      this.openFloor = val
      localStorage.setItem('fangTopenFloor', val)
    },
    toggleShowRmtype(val) {
      this.localShowRmtype = val
      localStorage.setItem('localShowRmtype', val)
    },
    getFloorTitle(str){
      var buildings = this.floorArr || []
      var temp = str
      buildings.map((item, index)=>{
        if(item.code == str){
          temp = item.name
        }
      })
      return temp
    },
    getBuildingTitle(str){
      var buildings = this.buildingArr || []
      var temp = str
      buildings.map((item, index)=>{
        if(item.code == str){
          temp = item.name
        }
      })
      return temp
    },
    getRoomServerList() {
      var self = this
      this.$http
        .post("/mobilepmsapi/reception/selectThefRomeClearUser", {
          noErrorToast: true
        })
        .then(res => {
          if (res.data.result == 0) {
            var a = res.data.retVal || []
            a.map((item) => {
              item.label = item.CODE + ' - ' + item.descript
              item.value = (item.CODE + '') || ''
            })
            self.serverList = res.data.retVal || []
          }
        });
    },

    initJingJiangListen() {
      let that = this
      if (this.isJingJiang && !this.listened) {
        this.listened = true
        document.addEventListener('resume', function () {
          that.closeDoorCardModal()
          let arg = plus.runtime.arguments || ''
          let lastInvokeId = localStorage.getItem('lastInvokeId') || ''
          // alert('fangT被唤醒，参数是：' + arg + ', listened' + that.listened + ',' + that.$route.name + ',' + lastInvokeId)
          //从后台切换到前台
          if (arg != '' && that.$route.name == 'fangT') {
            try {
              let temp = arg.split('//') || []
              let str = temp[1] || ''
              if (str) {
                let aj = that.parseQueryString(str)
                let roomNo = aj.roomNo || ''
                // alert('fantT lastInvokeId: ' + lastInvokeId + ', ajId: ' + aj.id)
                if (lastInvokeId && lastInvokeId == aj.id) {
                  // that.msg2('重复读卡')
                } else {
                  setTimeout(() => {
                    localStorage.setItem('lastInvokeId', aj.id)
                  }, 500)
                  if (roomNo) {
                    if (roomNo == '0') {
                      that.msg2(that.$t('jj_empty_card'))
                    } else {
                      that.doorCardModalShow = true
                      that.tempRoomNo = roomNo
                      that.ResponseParameters = aj || {}
                    }
                  } else {
                    // that.msg2(this.$t('jj_empty_card'))
                  }
                }
              }
              // 处理JSON对象aj
            } catch (e) {
              // 若传入的参数不是JSON格式字符，需处理异常情况
            }
          }

        }, false);
      }
    },
    closeDoorCardModal() {
      this.tempRoomNo = ''
      this.ResponseParameters = {
        roomNo: '',
        beginTime: '',
        endTime: '',
      }
      this.doorCardModalShow = false
    },
    searchDoorCardModal() {
      this.searchOption.searchText = this.tempRoomNo
      this.getData()
      this.closeDoorCardModal()
    },

    getJingJiangToken(action) {
      let objStr = localStorage.getItem('JingJiangSetting') || '{}'
      let obj = JSON.parse(objStr)
      this.chainNo = obj.HotelId || ''
      this.Key = obj.Key || ''
      obj.isJingJiangLocal = true
      // this.$http.post('/mobilepmsapi/pos/getJingJangToken', obj).then(res => {
      this.$http.post('/CardService/Authorize', obj).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {}
          this.jingJiangToken = retVal.Token || '';
          if (action == 'addCard') {
            this.addCard()
          } else if (action == 'readCard') {
            this.readCard()
          } else if (action == 'copyCard') {
            this.copyCard()
          } else if (action == 'cancelCard') {
            this.cancelCard()
          }
        } else {
          MessageBox.confirm(this.$t('jj_token_error'))
            .then(action => {
              if (action == 'confirm') {
                this.$router.push('/testjingjiang')
              }
            })
            .catch(action => {
            });
        }
      });
    },

    cancelCard() {
      const self = this
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Cancel',
        'CardType': this.configObj.CardType,
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        if (res.data.result == 0) {
          self.msg2(this.$t('jj_cancelCard_success'))
          self.closeDoorCardModal()
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    readCard() {
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': this.configObj.Category,
        'EventName': 'Read',
        'CardType': this.configObj.CardType,
      }
      this.wakeUpJingJiangApp()
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        if (res.data.result == 0) {
          // this.msg2('门卡读取成功')
          let retVal = res.data.retVal || {}
          this.ResponseParameters = retVal.ResponseParameters || {}
          this.searchOption.searchText = this.ResponseParameters.roomNo
          this.getData()
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },

    getLocalSearchOption() {
      let fangTSearchOption = this.$userLocal.getFangTSearchOption()
      if (fangTSearchOption) {
        let tempOption = JSON.parse(fangTSearchOption) || {}
        if (tempOption) {
          this.searchOption = tempOption
          if (!this.searchOption.villa) {
            this.searchOption.villa = 'V'
          }
          this.searchOption.searchText = ''
        }
      } else {
        if (!this.searchOption.villa) {
          this.searchOption.villa = 'V'
        }
      }
    },

    setLocalSearchOption() {
      this.$userLocal.setFangTSearchOption(JSON.stringify(this.searchOption))
    },

    startRecognize() {
      var options = {
        engine: 'iFly',
        punctuation: false
      };
      this.searchOption.searchText = '';
      console.log('开始语音识别');
      var that = this;
      plus.speech.startRecognize(
        options,
        function (s) {
          console.log(s);
          that.searchOption.searchText = _.trim(s);
          that.getData();
        },
        function (e) {
          //语音识别失败：
          that.msg2(this.$t('msg_recognize_fail') + e.message);
        }
      );
    },
    getFilter() {
      this.$http.post('/mobilepmsapi/reception/getRoomStatusFilter').then(res => {
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          this.buildingArr = retVal.building || []
          this.floorArr = retVal.floor || []
          this.serchList = retVal;
        } else {
          this.msg2(res.data.msg);
        }
      });
    },
    showFliter() {
      if (this.serchList.length == undefined) {
        this.popupVisible3 = true;
        return;
      }
      this.$http
        .post('/mobilepmsapi/reception/getRoomStatusFilter')
        .then(res => {
          if (res.data.result == 0) {
            this.popupVisible3 = true;
            var retVal = res.data.retVal || {}
            this.buildingArr = retVal.building || []
            this.serchList = retVal;
          } else {
            this.msg2(res.data.msg);
          }
        });
    },
    showStaOO(sta) {
      this.$http
        .post(
          '/mobilepmsapi/sys/pmsPrarms?type=' +
          (sta == 'O' ? 'MAINT_REASON' : 'LOCK_REASON')
        )
        .then(res => {
          this.staOOReq.sta = sta;
          this.staOOReq.rmnos = this.sheetTemp.rmno;
          this.staOOReq.beginDate = this.minDate;
          this.staOOReq.endDate = moment(
            moment()
              .add(1, 'd')
              .format('YYYY-MM-DD')
          ).toDate();
          this.popupVisibleSta = false;
          if (res.data.result == 0) {
            this.ooReasonSlot = res.data.retVal;
            this.popupVisibleStaOS = true;
          } else {
            this.msg2(res.data.msg);
          }
        });
    },
    handleConfirm(d) {
      if (moment(this.staOOReq.endDate) <= moment(this.staOOReq.beginDate)) {
        this.staOOReq.endDate = moment(
          moment(this.staOOReq.beginDate)
            .add(1, 'd')
            .format('YYYY-MM-DD')
        ).toDate();
      }
    },
    updateStaO() {
      this.staOOReq.beginDate = moment(this.staOOReq.beginDate).format(
        'YYYY-MM-DD'
      );
      this.staOOReq.endDate = moment(this.staOOReq.endDate).format(
        'YYYY-MM-DD'
      );
      if (this.staOOReq.reasonCode == '') {
        //请选择原因
        console.log(this.$t('msg_choose_reason'));
        this.msg2(this.msg_choose_reason);
        return;
      }
      this.popupVisibleStaOS = false;
      this.$http
        .post('/mobilepmsapi/reception/updateRoomStaOSOO', this.staOOReq)
        .then(res => {
          if (res.data.result == 0) {
            //更新成功
            this.msg2(this.msg_update_success);

            this.isMultSelect = false;
            this.$refs.topnav.selectMoreing = false;
            this.getData();
          } else {
            this.msg2(res.data.msg);
            this.popupVisibleStaOS = true;
          }
        });
    },
    openPick(p) {
      this.$refs[p].open();
    },
    updateSta() {
      if (this.updateRoomStaForThef && (this.staNew == 'R')) {
        this.updateStaWithHouseKeeper()
      } else {
        this.$http
          .post('/mobilepmsapi/reception/updateRoomSta', {
            sta: this.staNew,
            rmno: this.sheetTemp.rmno
          })
          .then(res => {
            this.popupVisibleSta = false;
            if (res.data.result == 0) {
              //更新成功
              this.msg2(this.msg_update_success);
              this.isMultSelect = false;
              this.$refs.topnav.selectMoreing = false;
              // console.log(this.isMultSelect)
              this.getData();
            } else {
              this.msg2(res.data.msg);
            }
          });
      }
    },

    updateStaWithHouseKeeper() {
      // 商务版并且干净的时候，走新的接口
      // 对应tapd：https://www.tapd.cn/21113861/prong/stories/view/1121113861001101324
      var url = '/mobilepmsapi/reception/updateRoomStaForThef'
      var param = {
        sta: this.staNew,
        rmno: this.sheetTemp.rmno,
        houseKeeper: this.houseKeeper || '',
      }
      this.$http
        .post(url, param)
        .then(res => {
          this.popupVisibleSta = false;
          this.houseKeeper = ''
          if (res.data.result == 0) {
            //更新成功
            this.msg2(this.msg_update_success);
            this.isMultSelect = false;
            this.$refs.topnav.selectMoreing = false;
            this.getData();
          } else {
            this.msg2(res.data.msg);
          }
        });
    },

    reserveBook() {
      this.sheetTemp.isReserve = true;
      this.$router.push({
        path: '/book?redirect=/fangT',
        query: this.sheetTemp
      });
    },
    walkBook() {
      this.sheetTemp.isReserve = false;
      this.$router.push({
        path: '/book?redirect=/fangT',
        query: this.sheetTemp
      });
    },
    geturl() {
      return this.$route.query.redirect || '/';
    },
    showFoot() {
      this.popupFootVisible = !this.popupFootVisible;
    },
    getData() {
      this.setLocalSearchOption()
      this.$http
        .post('/mobilepmsapi/reception/getRoomStatus', this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            var retVal = res.data.retVal || {}
            this.showBuilding = true // retVal.building
            this.showFloor = true // retVal.floor
            this.roomList = retVal;
            this.mutlSelectTitle = this.fangT_mutlSelectTitle;
            if(this.showBuilding){
              this.formatWithBuilding()
            } else {
              this.openBuilding = 'no'
            }

            if(this.showFloor){
              this.formatWithFloor()
            } else {
              this.openFloor = 'no'
            }
          } else {
            this.msg2(res.data.msg);
          }
        });
    },
    formatWithBuilding() {
      var roomList = this.roomList || {}
      var statusresult = roomList.statusresult || []
      var buildArr = _.union(_.pluck(statusresult, 'building'))
      var temp = []
      buildArr.map((code) => {
        var arr = []
        statusresult.map((item) => {
          if (item.building == code) {
            arr.push(item)
          }
        })
        temp.push({
          buildCode: code,
          list: arr
        })
      })
      this.withBuildDataArr = temp
    },


    formatWithFloor() {
      var roomList = this.roomList || {}
      var statusresult = roomList.statusresult || []
      // var floorArr = _.union(_.pluck(statusresult, 'floor'))
      var floorArr  = _.pluck(this.floorArr, 'code')

      var temp = []
      floorArr.map((code) => {
        var arr = []
        statusresult.map((item) => {
          if (item.floor == code) {
            arr.push(item)
          }
        })
        temp.push({
          floorCode: code,
          list: arr
        })
      })
      this.withFloorDataArr = temp
    },
    getIfPswd(){
      const self = this
      this.$http.post(`/mobilepmsapi/flat/getOptionValue`,{
        catalog: 'flat',
        item: 'mihotel_yunding_lock',
        noErrorToast: true
      }).then(res => {
        if (res.data.result == 0) {
          this.showPswd = res.data.retVal || 'F'

        } else {
          // self.msg2(res.data.msg)
        }
      });
    },
    pushInRight(vc) {
      if (this.useMhPermission) {
        this.newPerPushInRight(vc)
        return
      }
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      //查看
      this.actions.push({
        name: this.fangT_view,
        method: this.goFangTXQ
      });
      if (this.roomList.rights.indexOf('rmsta!rmsta') >= 0) {
        if (vc == 'D') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
        } else {
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        }
      }
      if (this.roomList.rights.indexOf('resrv!fit!add') >= 0) {
        //预订
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      this.addWx();
      this.sheetVisible = true;
    },

    newPerPushInRight(vc) {
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      //查看
      if (this.$hasPermission('mh!rm!resrv')) {
        this.actions.push({
          name: this.fangT_view,
          method: this.goFangTXQ
        });
      }

      if (this.$hasPermission('mh!rms!change')) {
        if (vc == 'D') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
        } else {
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        }
      }

      if (this.$hasPermission('mh!rm!resrv')) {
        //预订
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      this.addWx();
      this.sheetVisible = true;
    },

    pushRight(vc) {
      if (this.useMhPermission) {
        this.newPerPushRight(vc)
        return
      }
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      if (this.roomList.rights.indexOf('recept!fit!ci') >= 0) {
        //入住
        this.actions.push({
          name: this.fangT_walkBook,
          method: this.walkBook
        });
      }
      if (this.roomList.rights.indexOf('resrv!fit!add') >= 0) {
        //预订
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      if (this.roomList.rights.indexOf('rmsta!rmsta') >= 0) {
        if (vc == 'IS') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        } else if (vc == 'VD') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
        } else {
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        }
      }
      this.addWx();
      this.sheetVisible = true;
    },

    newPerPushRight(vc) {
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      if (this.$hasPermission('mh!rm!resrv')) {
        //入住
        this.actions.push({
          name: this.fangT_walkBook,
          method: this.walkBook
        });
      }
      if (this.$hasPermission('mh!rm!resrv')) {
        //预订
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      if (this.$hasPermission('mh!rms!change')) {
        if (vc == 'IS') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        } else if (vc == 'VD') {
          //干净
          this.actions.push({
            name: this.fangT_RoomStaR,
            method: this.updateRoomStaR
          });
        } else {
          //脏房
          this.actions.push({
            name: this.fangT_RoomStaD,
            method: this.updateRoomStaD
          });
        }
      }
      this.addWx();
      this.sheetVisible = true;
    },

    addWx() {
      if (!this.currentRoomName) {
        if (this.useMhPermission) {
          this.newPerAddWx()
          return
        }
        if (this.roomList.rights.indexOf('rmsta!ooo') >= 0) {
          //维修
          this.actions.push({
            name: this.fangT_RoomStaOOO,
            method: this.showStaOOO
          });
        }
        if (this.roomList.rights.indexOf('rmsta!os') >= 0) {
          //锁定
          this.actions.push({
            name: this.fangT_RoomStaOOS,
            method: this.showStaOOS
          });
        }
      }
    },

    newPerAddWx() {
      if (this.$hasPermission('mh!rms!change')) {
        //维修
        this.actions.push({
          name: this.fangT_RoomStaOOO,
          method: this.showStaOOO
        });
        //锁定
        this.actions.push({
          name: this.fangT_RoomStaOOS,
          method: this.showStaOOS
        });
      }
    },

    showStaOOO() {
      this.showStaOO('O');
    },
    showStaOOS() {
      this.showStaOO('S');
    },
    pushWxRight(vc) {
      if (this.useMhPermission) {
        this.newPerPushWxRight(vc)
        return
      }
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      this.actions.push({
        name: this.fangT_view,
        method: this.goRepair
      });

      if (this.roomList.rights.indexOf('rmsta!rmsta') >= 0) {
        this.actions.push({
          name: this.fangT_unRepair,
          method: this.unRepair
        });
      }
      if (this.roomList.rights.indexOf('resrv!fit!add') >= 0) {
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      this.sheetVisible = true;
    },

    newPerPushWxRight(vc) {
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      if (this.$hasPermission('mh!rm!resrv')) {
        this.actions.push({
          name: this.fangT_view,
          method: this.goRepair
        });
      }

      if (this.$hasPermission('mh!rms!change')) {
        this.actions.push({
          name: this.fangT_unRepair,
          method: this.unRepair
        });
      }
      if (this.$hasPermission('mh!rm!resrv')) {
        this.actions.push({
          name: this.fangT_reserveBook,
          method: this.reserveBook
        });
      }
      this.sheetVisible = true;
    },
    goPswd() {
      this.$router.push({
        path: '/tempPswd',
        query: {
          rmno: this.sheetTemp.rmno,
        }
      });
    },
    goRepair() {
      this.$router.push({
        path: '/repair',
        query: {
          rmno: this.sheetTemp.rmno,
          rmtype: this.sheetTemp.rmtype,
          roomSta: this.sheetTemp.pushWxRightroomSta
        }
      });
    },
    goFangTXQ() {
      this.$router.push({
        path: '/fangTXQ',
        query: this.sheetTemp
      });
    },
    unRepair() {
      //确定解除？
      this.confirm2(this.$t('MessageBox_unRepair'), action => {
        this.$http
          .post(
            '/mobilepmsapi/reception/updateRoomStaOSForCancel?rmno=' +
            this.sheetTemp.rmno
          )
          .then(res => {
            if (res.data.result == 0) {
              //更新成功
              this.msg2(this.msg_update_success);
              this.isMultSelect = false;
              this.$refs.topnav.selectMoreing = false;
              this.getData();
            } else {
              this.msg2(res.data.msg);
            }
          });
      })
    },
    updateRoomStaR() {
      this.staNew = 'R';
      this.popupVisibleSta = true;
    },
    updateRoomStaD() {
      this.staNew = 'D';
      this.popupVisibleSta = true;
    },
    setInfo(item) {
      if (item.status == this.searchOption.filterKey) {
        this.searchOption.filterKey = '';
      } else {
        this.searchOption.filterKey = item.status;
      }
      this.getData();
    },
    reset() {
      var villa = this.searchOption.villa;
      _.map(this.searchOption, (value, key) => {
        this.searchOption[key] = '';
      });
      this.searchOption.villa = villa;
    },
    handleTopChange: function (status) {
      this.topStatus = status;
    },
    loadTop() {
      this.getData();
      this.$refs.loadmore.onTopLoaded();
    },
    sendData() {
      this.popupVisible3 = false;
      this.setLocalSearchOption()
      this.getData();
    },
    selectSelf(node, item) {
      if (this.searchOption[node] == item.code) {
        this.searchOption[node] = '';
      } else {
        this.searchOption[node] = item.code;
      }
    },
    showmore(item) {
      this.rightList[item].more = this.rightList[item].more == 'T' ? 'F' : 'T';
    },

    touchitem(item) {
      if (this.isMultSelect) {
        //多选状态下
        // let mutlSelectLength=this.multChoicedArr.length
        this.$set(item, 'choiced', !item.choiced);
        let multChoicedArr = [];
        _.map(this.roomList.statusresult, (val, key) => {
          if (val.choiced) {
            multChoicedArr.push(val.rmno);
          }
        });
        //已选择 + 项
        this.mutlSelectTitle =
          this.fangT_mutlSelectTitleText + ' ' +
          multChoicedArr.length + ' ' + this.$t('fangT_mutlSelectTitUnit');
      } else {
        this.goToFangTXQ(item);
      }
    },
    goToFangTXQ(item) {
      this.currentRoomName = item.names // 当前选择的房间是否有人住，如果有人住了，就不能改为维修和锁定
      this.sheetTemp = {
        rmno: item.rmno,
        rmtype: item.rmtype,
        pushWxRightroomSta: item.roomSta
      };
      if (item.arr == 'T' || (item.sta == 'IS' && item.names != '')) {
        this.pushInRight(item.roomSta);
        return;
      } else {
        var path = 'fangTXQ'; //根据订单状态 判断按钮
        switch (item.sta) {
          case 'VC':
          case 'VD':
          case 'IS':
            path = '/book'; //入住中(页面不变，按钮变)
            this.pushRight(item.sta);
            return;
          case 'OS':
          case 'OO':
            this.pushWxRight(item.sta);
            return;
          //  case "OC":
          //    break;
          default:
            this.pushInRight(item.roomSta);
            return;
        }
        this.$router.push({
          path: path,
          query: this.sheetTemp
        });
      }
    },
    operateMultSelected() {
      let multChoicedArr = [];
      _.map(this.roomList.statusresult, (val, key) => {
        if (val.choiced) {
          multChoicedArr.push(val.rmno);
        }
      });
      if (multChoicedArr.length == 0) {
        //至少选择一个房间
        this.msg2(this.msg_choose_room);
        return;
      }
      this.multRoomOperate(multChoicedArr);
    },
    multRoomOperate(multRoomNums) {
      if (this.useMhPermission) {
        this.newPerMultRoomOperate(multRoomNums)
        return
      }
      this.sheetTemp = {
        rmno: multRoomNums.join(',')
      };
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      if (this.roomList.rights.indexOf('rmsta!rmsta') >= 0) {
        //干净
        this.actions.push({
          name: this.fangT_RoomStaR,
          method: this.updateRoomStaR
        });
        //脏房
        this.actions.push({
          name: this.fangT_RoomStaD,
          method: this.updateRoomStaD
        });
        //解除
        this.actions.push({
          name: this.fangT_unRepair,
          method: this.unRepair
        });
      }
      if (this.roomList.rights.indexOf('rmsta!ooo') >= 0) {
        //维修
        this.actions.push({
          name: this.$t('fangT_RoomStaOOO'),
          method: this.showStaOOO
        });
      }
      if (this.roomList.rights.indexOf('rmsta!os') >= 0) {
        //锁定
        this.actions.push({
          name: this.$t('fangT_RoomStaOOS'),
          method: this.showStaOOS
        });
      }
      // 多房型预定
      if (this.roomList.rights.indexOf('resrv!fit!add') >= 0) {
        this.actions.push({
          name: this.$t('fangT_reserveBook'),
          method: this.doMultipleBook
        });
      }
      // 多房型入住
      if (this.roomList.rights.indexOf('recept!fit!ci') >= 0) {
        this.actions.push({
          name: this.$t('fangT_walkBook'),
          method: this.doMultipleBookIn
        });
      }
      this.sheetVisible = true;
    },

    newPerMultRoomOperate(multRoomNums) {
      this.sheetTemp = {
        rmno: multRoomNums.join(',')
      };
      this.actions = [];
      if(this.showPswd == 'T'){
        this.actions.push({
          name: '查看临时密码',
          method: this.goPswd
        })
      }
      if (this.$hasPermission('mh!rms!change')) {
        //干净
        this.actions.push({
          name: this.fangT_RoomStaR,
          method: this.updateRoomStaR
        });
        //脏房
        this.actions.push({
          name: this.fangT_RoomStaD,
          method: this.updateRoomStaD
        });
        //解除
        this.actions.push({
          name: this.fangT_unRepair,
          method: this.unRepair
        });
      }
      if (this.$hasPermission('mh!rms!change')) {
        //维修
        this.actions.push({
          name: this.$t('fangT_RoomStaOOO'),
          method: this.showStaOOO
        });
      }
      if (this.$hasPermission('mh!rms!change')) {
        //锁定
        this.actions.push({
          name: this.$t('fangT_RoomStaOOS'),
          method: this.showStaOOS
        });
      }
      // 多房型预定
      if (this.$hasPermission('mh!rm!resrv')) {
        this.actions.push({
          name: this.$t('fangT_reserveBook'),
          method: this.doMultipleBook
        });
      }
      // 多房型入住
      if (this.$hasPermission('mh!rm!resrv')) {
        this.actions.push({
          name: this.$t('fangT_walkBook'),
          method: this.doMultipleBookIn
        });
      }
      this.sheetVisible = true;
    },

    doMultipleBook() {
      let allArr = this.roomList.statusresult || []
      let tempArr = allArr.filter((item, index) => {
        return item.choiced
      })
      this.$store.commit('submitMultipleBookRoomList', tempArr);
      this.$router.push('/book?redirect=/fangT&isMultipleBook=yes')
    },
    doMultipleBookIn() {
      let allArr = this.roomList.statusresult || []
      let tempArr = allArr.filter((item, index) => {
        return item.choiced
      })
      this.$store.commit('submitMultipleBookRoomList', tempArr);
      this.$router.push('/book?redirect=/fangT&isMultipleBook=yes&isMultipleBookIn=yes')
    },

    cancleSelectMore() {
      this.isMultSelect = false;
      //已选择 0 项"
      this.mutlSelectTitle = this.fangT_mutlSelectTitle;
      _.map(this.roomList.statusresult, (val, key) => {
        if (val.choiced) {
          val.choiced = false;
        }
      });
    },
    goSelect() {
      this.isMultSelect = true;
      this.multChoicedArr = [];
    }
  },
  computed: {
    msg_choose_reason() {
      return this.$t('msg_choose_reason');
    },
    msg_update_success() {
      return this.$t('msg_update_success');
    },
    msg_choose_room() {
      return this.$t('msg_choose_room');
    },

    fangT_mutlSelectTitle() {
      return this.$t('fangT_mutlSelectTitle');
    },
    fangT_mutlSelectTitleText() {
      return this.$t('fangT_mutlSelectTitleText');
    },
    fangT_mutlSelectTitUnit() {
      return this.$t('fangT_mutlSelectTitUnit');
    },
    fangT_view() {
      return this.$t('fangT_view');
    },
    fangT_RoomStaR() {
      return this.$t('fangT_RoomStaR');
    },
    fangT_RoomStaD() {
      return this.$t('fangT_RoomStaD');
    },
    fangT_reserveBook() {
      return this.$t('fangT_reserveBook');
    },
    fangT_walkBook() {
      return this.$t('fangT_walkBook');
    },
    fangT_RoomStaOOO() {
      return this.$t('fangT_RoomStaOOO');
    },
    fangT_RoomStaOOS() {
      return this.$t('fangT_RoomStaOOS');
    },
    fangT_unRepair() {
      return this.$t('fangT_unRepair');
    },

    hasSelectFilter: function () {
      let flag = false
      let searchOption = this.searchOption || {}
      for (var key in searchOption) {
        if (key != 'searchText' && key != 'villa' && searchOption[key]) {
          flag = true
        }
      }
      return flag
    }
  },
  filters: {
    fdate(value) {
      return moment(value).format('YYYY-MM-DD');
    }
  },
  components: {
    actionsheet: Actionsheet,
    nothing
  }
};
</script>

<style lang="less"
       scoped>
.ft {
  height: 100%;

  .door-card-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1111;

    .door-card-container {
      overflow: hidden;
      position: fixed;
      width: 80%;
      background: #fff;
      z-index: 12;
      border-radius: 10px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;

      .door-card-title {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eee;
        text-align: center;
      }

      .door-card-info {
        box-sizing: border-box;
        height: 140px;

        .info-item {
          padding: 10px 15px;
          display: flex;

          .info-item-label {
            color: #333;
            width: 80px;
          }

          .info-item-content {
            color: #666;
          }
        }
      }

      .door-card-bottom {
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #eee;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .door-btns {
          flex: 1;
          text-align: center;
          display: inline-block;
          box-sizing: border-box;
          border-right: 1px solid #eee;

          &:last-child {
            border-right: none;
          }
        }

      }
    }
  }

  .fangt_top {
    height: 1.26666667rem;
    width: 100%;
    background: #fff;
    padding: 0.18666667rem 0;
    box-sizing: border-box;
    position: absolute;
    top: 1.04rem;
    left: 0;
    z-index: 999;

    .mintui-back {
      font-size: 0.7rem;
      line-height: 0.853333rem;
    }

    .search {
      margin-left: 0.14rem;
      border-radius: 0.44rem;
      width: 6.1rem;
      float: left;
      height: 0.85333333rem;
      background-color: #f7f8fa;
      padding: 0 0.26666667rem;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      i.icon-sousuo {
        vertical-align: bottom;
        font-size: 0.42666667rem;
        color: #ccc;
        line-height: 0.89333333rem;
      }

      input {
        padding-left: 0.2rem;
        width: 3.28rem;
        vertical-align: middle;
        flex: 1;
        //margin-bottom: 0.13333rem;
        height: 0.62666667rem;
        background-color: #f7f8fa;
        outline: 0;
        border: 0;
      }

      .cleartext {
        float: right;

        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #c3c3c3;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13333333rem;
          margin-top: 0.13333333rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }

        i.icon-yuyin {
          line-height: 0.85333333rem;
          font-size: 0.5rem;
          color: #999;
          text-align: center;
          padding-right: 0.13333333rem;
          display: inline-block;
        }

        i.icon-qiapian {
          line-height: 0.85333333rem;
          font-size: 0.5rem;
          color: #999;
          text-align: center;
          padding-right: 0.13333333rem;
          display: inline-block;
        }
      }
    }

    .searct_btn {
      width: 1.73333333rem;
      box-sizing: border-box;
      text-align: center;
      float: left;
      height: 100%;
      font-size: 0.32rem;
      line-height: 0.89333333rem;
      color: #5b5b5b;
    }

    .line {
      float: left;
      width: 0.02666667rem;
      height: 0.53333333rem;
      background-color: #ccc;
      margin-top: 0.21333333rem;
    }

    .fliter {
      width: 1.86666667rem;
      float: right;
      height: 100%;
      text-align: center;
      font-size: 0.32rem;
      line-height: 0.89333333rem;
      box-sizing: border-box;
      padding-right: 0.3rem;
      color: #5b5b5b;
      position: relative;

      .iconfont {
        position: absolute;
        display: inline-block;
        color: #999;
        margin-left: .1rem;
      }

      .filter-red-dot {
        position: absolute;
        top: 0.18rem;
        left: 1.05rem;
        background: #ff471d;
        width: 6px;
        height: 6px;
        border-radius: 6px;
      }

    }
  }

  .all_ft {
    width: 100%;
    margin-top: 2.332rem;

    .build-wrap {
      overflow: hidden;
      margin-bottom: 30px;
      .build-title{
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        border-left: 5px solid orange;
        margin-left: 5px;
        margin-bottom: 5px;
      }
      .floor-title{
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        border-left: 5px solid #428bca;
        margin-left: 5px;
        margin-bottom: 5px;
      }
    }

    .roomList {
      width: 2rem;
      min-width: 2rem;
      max-width: 2.17rem;
      height: 2rem;
      position: relative;
      top: 0.02666667rem;
      float: left;
      color: #fff;

      &.roomListJingJiang {
        width: 2.32rem;
      }

      .item {
        border-bottom: 1px solid #fff;
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        background-color: #00cfcf;
        overflow: hidden;
        position: relative;

        &:active {
          border: 1px solid #eaeaea;
        }

        &.rightBorder {
          border-right: 1px solid #fff;
        }

        p {
          text-align: center;
          margin: 0;
        }

        .room-status-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 0.45rem;
          height: 0.45rem;
          line-height: 0.45rem;
          font-size: 0.28rem;
          /*background: #ec5861;*/
          color: #fff;
          text-align: right;
        }

        .roomNo {
          font-size: 0.32rem;
          height: 0.6rem;
          line-height: 0.6rem;
        }

        .roomType {
          box-sizing: border-box;
          padding: 0 0.06666667rem;
          font-size: 0.32rem;
          line-height: 0.66666667rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &.arrT {
          .roomType {
            line-height: 0.45rem;
          }
        }

        .rms {
          font-size: 0.25rem;
        }

        .multChoice {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: 1;

          .mult-cicle {
            display: none;
            position: absolute;
            border-radius: 50%; // border: 1px #f7f8fa solid;
            box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
            background: #1470df;
            right: 7px; // left: 0;
            // top: 0;
            bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
            width: 20px;
            height: 20px;
            text-align: center;
          }

          &.choiced {
            background-color: rgba(0, 0, 0, 0);

            .mult-cicle {
              display: block;

              .iconfont {
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

  .foot_ft {
    box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 0 0.18666667rem;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 1;

    .footPop {
      width: ~"calc(100% - .9rem)";
      left: ~"calc(50% - .5rem)";
      box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
      opacity: 0;
    }

    .showFBtn {
      transition: all 0.1s ease-in-out;
      position: fixed;
      right: 0;
      bottom: 0;
      height: 1rem;
      z-index: 3000;
      width: 1rem;
      text-align: center;
      line-height: 1rem;
      background: #ffffff;
      box-shadow: -0.02666667rem 0 0.10666667rem 0 rgba(0, 0, 0, 0.18);

      .iconfont {
        color: #9b9b9b;
        font-size: 0.37333333rem;
      }
    }

    @media only screen and (max-device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      .showFBtn {
        height: 1.8933rem;
        line-height: 1.8933rem;
      }
    }

    .foot_c {
      height: 1rem;
      width: ~"calc(100% - 1rem)";
      width: 100%;
      background-color: #fff;
      border-bottom: 1px solid #ddd;
      padding: 0.16rem 0.26666667rem;
      box-sizing: border-box;
      overflow-y: hidden;
      overflow-x: auto;

      .top {
        margin-top: 0.1rem; // margin-left: 0.36rem;
        // margin-right: 0.15rem;
        float: left;
        text-align: left;
        color: #333; // padding: 0.05333333rem 0;
        padding: 0.1rem 0.1867rem;
        box-sizing: border-box;

        .cicle {
          width: 0.33333333rem;
          height: 0.33333333rem;
          margin-right: 0.08rem;
          margin-top: -0.04rem;
          float: left;
          border-radius: 50%;
          border: 1px solid #969696;
          vertical-align: middle;

          .dep-icon {
            font-size: 0.24rem;
            color: #fff;
            position: relative;
            left: 0.1rem;
          }
        }
      }

      .checked {
        background: #f98f3c;
        border-radius: 0.26666667rem;
        padding: 0.1rem 0.1867rem;
        color: #fff;

        .cicle {
          border: none;
          background: #fff; //   border: 1px solid #969696;
          margin-top: 0px;
        }
      }
    }

    .foot_d {
      /*height: 1rem;*/
      background-color: #fff;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      height: 1rem;
      transition: all 0.3;
    }

    .flotwarp {
      width: 18rem; //   transition: all 0.1s ease-in-out;

      .bottom {
        margin: 0.21333333rem 0 0 0;
        float: left;
        text-align: left;
        height: 100%;
        color: #333;
        line-height: 1rem;
        line-height: 0.56rem;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;

        width: auto;

        .checkbox {
          display: inline-block;
          padding: 0 0.26666667rem;
          text-align: center;

          &.checked {
            background: #f98f3c;
            border-radius: 0.26666667rem;
            color: #fff;
          }

          .dimetric {
            width: 0.33333333rem;
            height: 0.33333333rem;
            margin-right: 0.08rem;
            float: left;
            border-radius: 0.1rem;
            border: 1px solid #969696;
            margin-top: 0.08rem;
            background: #fff;
          }
        }

        .change {
          width: 33.3%;
        }
      }
    }
  }

  .change {
    .footPop {
      opacity: 1;
    }

    box-shadow: none;

    .showFBtn {
      height: 3.96rem;
      transition: all 0.1s ease-in-out;

      .iconfont {
        line-height: 3.96rem;
        font-size: 0.37333333rem;
        transform: rotate(180deg);
        display: inline-block;
      }
    }

    .foot_d {
      overflow-y: inherit;
      height: 2.96rem;
      width: ~"calc(100% - 1rem)";

      .flotwarp {
        width: 100%;

        .bottom {
          width: 33.3%;
        }
      }
    }
  }

  .mint-popup-3 {
    width: 6.13333333rem;
    height: 100%;

    .rightFliterBox {
      overflow: auto;
      width: 6.13333333rem;
      height: 100%;
      top: 0;
      background-color: #fff;
      transition: right 0.5s ease-in-out;
      box-shadow: 0 0.02666667rem 0.4rem #0006;

      .filter_title {
        width: 100%;
        height: 1.2rem;

        .title {
          float: left;
          line-height: 1.2rem;
          font-size: 0.4rem;
          margin-left: 0.4rem;
        }

        .mint-button {
          float: right;
          height: 100%;
          background: #fff;
          box-shadow: none;

          .icon-cuowu {
            float: right;
            margin-right: 0.0267rem;
            line-height: 1.2rem;
            font-size: 0.4rem;
          }
        }
      }

      .fliter_item {
        margin-top: 0.4rem;
        padding: 0 0.26666667rem;

        &:nth-last-of-type(2) .category_list {
          border-bottom: 1.33333333rem solid #fff;
        }

        .category_name {
          height: 0.33333333rem;
          margin: 0 0.26666667rem 0.06666667rem;

          span {
            font-size: 0.26666667rem;
            color: #9b9b9b;
          }

          .showCategory {
            float: right;
            color: #606060;
            font-size: 0.26666667rem;

            .iconfont {
              margin-left: 5px;
              font-size: 0.26666667rem;
              transition: all 0.2s linear;
              display: inline-block;

              &.open {
                transform: rotate(180deg);
              }
            }
          }
        }

        .category_list {
          padding: 0.26666667rem 0 0.12rem;
          border-bottom: 0.02666667rem solid #efefef;

          .option {
            font-size: 0.33333333rem;
            width: 1.6rem;
            margin: 0px 0.13333333rem 0.26666667rem;
            float: left;
            border-radius: 0.10666667rem;
            background-color: #efefef;
            color: #606060;
            text-align: center;
            line-height: 0.69333333rem;
            overflow: hidden;
            height: 0.69333333rem;
          }

          & .checked {
            background-color: #f98f3c;
            color: #fff !important;
          }

          &.twocol {
            height: 1.78666667rem;
            overflow: hidden;

            &.show {
              height: auto;
            }

            .option {
              width: 2.53333333rem;
              color: #333333;
            }
          }
        }
      }

      .bottom_f {
        position: fixed;
        width: 6.13333333rem;
        bottom: 0;
        height: 1.2rem;
        padding: 0.26666667rem 0;
        box-sizing: border-box;
        color: #fff;
        background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
        background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
        background-image: linear-gradient(to left, #ff5a51, #ffa500);

        .reset {
          float: left;
          text-align: center;
          font-size: 0.42666667rem;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          width: 50%;
          box-sizing: border-box;
          border-right: 0.02666667rem solid #fff;
        }

        .success {
          float: left;
          width: 50%;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          text-align: center;
          font-size: 0.42666667rem;
        }
      }
    }
  }

  .fboot {
    height: 1rem;
    display: block;
  }

  .mint-loadmore {
    position: absolute;
    top: 0px;
    bottom: 40px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .mint-loadmore-top {
    font-size: 0.42rem;
    color: #606060;
  }

  .checkOutPop {
    width: 100%;
    height: 80%;
    margin-top: 20%;
    background: #fff;

    .checkList {
      width: 90%;
      height: 40px;
      padding: 5px 10px;
      text-align: left;
      line-height: 40px;
      margin: 0 auto;
      font-size: 18px;
      border-bottom: 1px dashed #efefef;
      position: relative;
      word-break: break-all;
      font-size: 14px;

      &.mutlList {
        height: auto;
        max-height: 120px;
        overflow-y: auto;
      }

      //       overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      label {
        height: 40px;
        line-height: 40px;

        float: left;
        font-size: 16px;
      }
    }

    .ooreason {
      width: 5rem;
      height: 0.8rem;
      margin-top: 0.08rem;
      border: 1px solid #ccc;

      line-height: 0.64rem;
    }

    .popBottom {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

      .cCancle,
      .cSure {
        float: left;
        height: 100%;
        width: 50%;
        color: #fff;
        font-size: 16px;
        box-sizing: border-box;
        border-right: 2px solid #fff;
        text-align: center;
        line-height: 45px;
      }

      .cSrue {
        border-right: none;
      }
    }
  }

  .pos {
    //   z-index:101 !important;
    height: 80%;
    font-size: 14px;

    .checkList {
      font-size: 14px;
      height: 35px;

      label {
        width: 100px;
      }
    }
  }

  .bgnothing {
    text-align: center;
    margin-top: 4.9333rem;
    margin: 4.9333rem 0 0 3.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// fangT.vue?1975e7e0